module.exports = __webpack_public_path__ + "img/btn3.8abe227d.png";